import { gql } from '@apollo/client';

export const UpdateSocialMedia = gql`
mutation UpdateSocialMedia($updateSocialMediaId: ID!, $content: contentSocialMedia!) {
  updateSocialMedia(id: $updateSocialMediaId, content: $content) {
    status
  }
}
`;